import { iCaseComponentsResultItem } from '@/Interfaces/caseComponentsLib';
export const itemBoxHolder: iCaseComponentsResultItem = {

    id: crypto.randomUUID(),
    prototypeId: 'box_hol_200_SPBH',
    indexPositionY: 0,
    isLeft: false,
    isDefaultHolder: true,
};
